export enum CompanyUserMemberRoleEnum {
  ACCOUNT_MANAGER = 'account-manager',
}
